import axios from 'axios';

// 自动检测API地址：如果通过IP访问，使用相同的IP；否则使用localhost
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  const hostname = window.location.hostname;

  // 本地开发
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5002/api';
  }
  // 局域网 IP 直连后端 5002
  if (/^[0-9.]+$/.test(hostname)) {
    return `http://${hostname}:5002/api`;
  }
  // 生产域名（yx.serenejade.com）：同源，由 nginx 反代 /api → Flask
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();
console.log('🔗 API地址:', API_BASE_URL);

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 认证API
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  verify: () => api.get('/auth/verify'),
};

// 发件邮箱API
export const senderEmailAPI = {
  getAll: () => api.get('/sender-emails'),
  add: (data) => api.post('/sender-emails', data),
  update: (id, data) => api.put(`/sender-emails/${id}`, data),
  delete: (id) => api.delete(`/sender-emails/${id}`),
};

// 公司/律所API
export const companyAPI = {
  getAll: (params) => api.get('/companies', { params }),
  getOne: (id) => api.get(`/companies/${id}`),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`),
};

// 收件人API
export const recipientAPI = {
  getAll: (params) => api.get('/recipients', { params }),
  add: (data) => api.post('/recipients', data),
  update: (id, data) => api.put(`/recipients/${id}`, data),
  delete: (id) => api.delete(`/recipients/${id}`),
};

// 营销活动API
export const campaignAPI = {
  getAll: () => api.get('/campaigns'),
  getOne: (id) => api.get(`/campaigns/${id}`),
  create: (data) => api.post('/campaigns', data),
  update: (id, data) => api.put(`/campaigns/${id}`, data),
  send: (id, recipients) => api.post(`/campaigns/${id}/send`, { recipients }),
};

// Follow-up API
export const followupAPI = {
  getConfig: (campaignId) => api.get(`/campaigns/${campaignId}/followup`),
  saveConfig: (campaignId, data) => api.post(`/campaigns/${campaignId}/followup`, data),
  getSchedules: (params) => api.get('/followup-schedules', { params }),
};

// 邮件日志API
export const emailLogAPI = {
  getAll: (params) => api.get('/email-logs', { params }),
};

// 统计API
export const statsAPI = {
  get: () => api.get('/stats'),
};

// 签名API
export const signatureAPI = {
  getAll: () => api.get('/signatures'),
  create: (data) => api.post('/signatures', data),
  update: (id, data) => api.put(`/signatures/${id}`, data),
  delete: (id) => api.delete(`/signatures/${id}`),
};

// 预览API
export const previewAPI = {
  email: (content, signature_id) => api.post('/preview-email', { content, signature_id }),
  personalize: (subject, content) => api.post('/personalize-preview', { subject, content }),
};

// 系统设置（发送节流 / 每日上限 / 退订域名）
export const settingsAPI = {
  get: () => api.get('/settings'),
  save: (data) => api.post('/settings', data),
};

// CSV 批量导入收件人
export const importAPI = {
  upload: (file, tags) => {
    const fd = new FormData();
    fd.append('file', file);
    if (tags) fd.append('tags', tags);
    return api.post('/recipients/import', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// 线索查找器（英国移民所）
export const leadAPI = {
  find: (data) => api.post('/leads/find', data),
  status: () => api.get('/leads/status'),
  stop: () => api.post('/leads/stop'),
  list: (status = 'new') => api.get('/leads', { params: { status } }),
  import: (data) => api.post('/leads/import', data),
  clear: () => api.post('/leads/clear'),
};

export default api;

